/* eslint-disable no-empty */
/* eslint-disable no-cond-assign */
/* Script for analytics downloaded from FR AWS. Provided and maintained by TraceDock analytics company. */
!(function (e, t, n, r, o, i, u, c, a, l) {
  (a = n.getElementsByTagName("head")[0]),
    ((l = n.createElement("script")).async = 1),
    (l.src = t),
    a.appendChild(l),
    (r = n.cookie);
  try {
    if ((i = (" " + r).match(new RegExp("[; ]_tdbu=([^\\s;]*)"))))
      for (u in (o = decodeURI(i[1]).split("||")))
        (c = o[u].split("~~"))[1] &&
          (r.indexOf(c[0] + "=") > -1 ||
            ((n.cookie = c[0] + "=" + c[1] + ";path=/;max-age=604800;domain=." + e),
            (n.cookie = "_1=1")));
  } catch (e) {}
})("kiiroo.com", "https://s4.kiiroo.com/main.js", document);
